"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDropOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.drop-off_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "drop-off_outline_svg__transparent_box" },
            React.createElement("path", { className: "drop-off_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "drop-off_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "drop-off_outline_svg__OUTLINE" },
            React.createElement("path", { className: "drop-off_outline_svg__cls-1", d: "M9.79 25A8 8 0 0024 20a16.16 16.16 0 00-2-7.14z" }),
            React.createElement("path", { d: "M30 2L2 30h2.82l3.55-3.55A10 10 0 0026 20a18.86 18.86 0 00-2.55-8.62L30 4.82zm-6 18a8 8 0 01-14.2 5L22 12.86A16.16 16.16 0 0124 20zM16 4.48c.68.75 1.77 2 2.93 3.58l1.44-1.44a43.36 43.36 0 00-3.67-4.33l-.7-.72-.71.74C14.89 2.71 6 12.15 6 20c0 .32 0 .63.07.94l2-2C8.69 13.3 14.05 6.71 16 4.48zM2 30z" }))));
}
exports.default = SvgDropOffOutline;
//# sourceMappingURL=DropOffOutline.js.map